import axios from 'axios';

const API_KEY = '52964792-0363318bc9d3339fdc2c94caa';
const BASE_URL = 'https://pixabay.com/api/';

export async function fetchImages(query, page = 1) {
  const params = {
    key: API_KEY,
    q: query,
    image_type: 'photo',
    orientation: 'horizontal',
    safesearch: true,
    per_page: 15,
    page,
  };

  const response = await axios.get(BASE_URL, { params });
  return {
    images: response.data.hits,
    totalHits: response.data.totalHits,
  };
}
